import { call, put } from 'redux-saga/effects';
import { deleteAttachmentsAction, deleteAttachmentsSaga, deleteAttachmentsSuccessAction } from "../../attachment";
import { questionnaireEvaluationDeleteAttachmentSuccess, questionnaireEvaluationFailureAction } from '../actions';
export function* questionnaireEvaluationDeleteAttachmentSaga(action) {
    try {
        yield call(deleteAttachmentsSaga, deleteAttachmentsAction(action.payload));
        yield put(deleteAttachmentsSuccessAction([action.payload[0].id]));
        yield put(questionnaireEvaluationDeleteAttachmentSuccess(action.payload[0]));
    }
    catch (error) {
        yield put(questionnaireEvaluationFailureAction(error.toString()));
    }
}
//# sourceMappingURL=questionnaireEvaluationDeleteAttachmentSaga.js.map